import React from 'react';

export function TestPageLoad() {
  return <div style={{ width: '1px', height: '1px' }} className="page-load" />;
}
